export default __webpack_public_path__ + "static/media/Mission.08308abf.svg";